import { render } from "./QuranRukukList.vue?vue&type=template&id=e97706ca"
import script from "./QuranRukukList.vue?vue&type=script&lang=js"
export * from "./QuranRukukList.vue?vue&type=script&lang=js"
script.render = render

export default script